import React, { useState } from 'react';
import { trackEvent } from '../../analytics';

// Web3Forms access keys are public by design: the key only lets a form send mail to
// the inbox it is registered to. It is read from .env at build time.
const ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

const inputClass =
  'w-full rounded-2xl border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder:text-gray-400 focus:border-clay focus:outline-none focus:ring-2 focus:ring-clay/30 transition-colors';

export default function ContactForm() {
  // idle | sending | success | error
  const [status, setStatus] = useState('idle');

  const onSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    formData.append('access_key', ACCESS_KEY);

    setStatus('sending');
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.success) {
        setStatus('success');
        trackEvent('form_submit', { form_name: 'contact' });
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-5">
      <input type="hidden" name="subject" value="New message from mubarakfarmug.com" />
      <input type="hidden" name="from_name" value="Mubarak Farm website" />
      {/* Honeypot: Web3Forms rejects submissions where this box is checked. */}
      <input type="checkbox" name="botcheck" className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="contact-name" className="block text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-2">Name</label>
          <input id="contact-name" type="text" name="name" required autoComplete="name" className={inputClass} />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-2">Email</label>
          <input id="contact-email" type="email" name="email" required autoComplete="email" className={inputClass} />
        </div>
      </div>

      <div>
        <label htmlFor="contact-message" className="block text-xs font-semibold uppercase tracking-[0.2em] text-clay mb-2">Message</label>
        <textarea
          id="contact-message"
          name="message"
          required
          rows={5}
          placeholder="Grade, quantity, city, or anything else we should know."
          className={`${inputClass} resize-y`}
        />
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <button
          type="submit"
          disabled={status === 'sending'}
          className="inline-flex items-center justify-center bg-gold-500 hover:bg-gold-400 disabled:opacity-60 disabled:cursor-wait text-gray-900 font-bold px-10 py-4 rounded-full transition-[background-color,transform] duration-200 active:scale-[0.97]"
        >
          {status === 'sending' ? 'Sending...' : 'Send message'}
        </button>
        <p role="status" aria-live="polite" className="text-sm">
          {status === 'success' && <span className="text-gray-700">Thank you. We reply within 24 hours.</span>}
          {status === 'error' && (
            <span className="text-clay">
              The message did not send. Please try again, or email{' '}
              <a href="mailto:mubarakfarm53@gmail.com" className="underline">mubarakfarm53@gmail.com</a>.
            </span>
          )}
        </p>
      </div>
    </form>
  );
}
